/** admin/campaigns — API. */
import { http } from '../../_shared/http';
import type {
  CampaignTemplateSummary,
  AdminCampaign,
  CreateCampaignPayload,
  UpdateCampaignPayload,
} from './types';

export const campaignsApi = {
  // Templates
  listTemplates: () => http.get<CampaignTemplateSummary[]>('/admin/campaigns/templates'),

  // Campaigns
  list: () => http.get<AdminCampaign[]>('/admin/campaigns'),
  get: (id: string) => http.get<AdminCampaign>(`/admin/campaigns/${id}`),
  create: (payload: CreateCampaignPayload) => http.post<{ id: string }>('/admin/campaigns', payload),
  update: (id: string, payload: UpdateCampaignPayload) => http.patch<AdminCampaign>(`/admin/campaigns/${id}`, payload),
  remove: (id: string) => http.del<void>(`/admin/campaigns/${id}`),
  updateChapter: (
    campaignId: string,
    chapterId: string,
    payload: { startTime?: string | null; endTime?: string | null },
  ) =>
    http.patch<{ id: string; startDateUtc: number | null; endDateUtc: number | null }>(
      `/admin/campaigns/${campaignId}/chapters/${chapterId}`,
      payload,
    ),
};
